import { useQuery } from "@tanstack/react-query";
import { getTotalTakePictureFrameApiRequest } from "../../services/frame/get.total.take.picture.frame.api";

export const useGetTotalTakePictureOfFrameApi = ({
  active,
  startDate,
  endDate,
}: any) => {
  const { data, isLoading } = useQuery({
    queryKey: ["frame-analystic", startDate, endDate, active],
    queryFn: () =>
      getTotalTakePictureFrameApiRequest({ active, startDate, endDate }),
    enabled: !!startDate && !!endDate,
  });
  return {
    totalTakePictureOfFrame: data,
    isLoading,
  };
};
